module.exports = __webpack_public_path__ + "media/images/loupenoir-20cd3921e6ce7f4c4fa796c969036b21.svg";